/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV input`)
};

const es_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada CSV`)
};

const de_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV-Eingabe`)
};

const nl_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV-invoer`)
};

const fr_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrée CSV`)
};

const it_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input CSV`)
};

const pt_br2_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada de CSV`)
};

const pt_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada de CSV`)
};

const ja_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 入力`)
};

const zh_cj_csv_input = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 输入`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_csv_input = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_csv_input(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_csv_input", locale)
	if (locale === "en") return en_cj_csv_input(inputs)
	if (locale === "es") return es_cj_csv_input(inputs)
	if (locale === "de") return de_cj_csv_input(inputs)
	if (locale === "nl") return nl_cj_csv_input(inputs)
	if (locale === "fr") return fr_cj_csv_input(inputs)
	if (locale === "it") return it_cj_csv_input(inputs)
	if (locale === "pt-BR") return pt_br2_cj_csv_input(inputs)
	if (locale === "pt") return pt_cj_csv_input(inputs)
	if (locale === "ja") return ja_cj_csv_input(inputs)
	return zh_cj_csv_input(inputs)
};